module.exports = __webpack_public_path__ + "images/bmw_smallf57b2a993182df03a9a4027e0fc8b6d8.png";